import { render, staticRenderFns } from "./enlargeImg.vue?vue&type=template&id=64d99526"
import script from "./enlargeImg.vue?vue&type=script&lang=js"
export * from "./enlargeImg.vue?vue&type=script&lang=js"
import style0 from "./enlargeImg.vue?vue&type=style&index=0&id=64d99526&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports